import styled from 'styled-components'

export const StyledIngredientList = styled.div`
  margin: 16px 0 24px;
`
